var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinemaSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cinema 1",
    clipPath: "url(#clip0_4091_10979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56 0H4C1.79086 0 0 1.79086 0 4V31.9766C0 34.1857 1.79086 35.9766 4 35.9766H56C58.2091 35.9766 60 34.1857 60 31.9766V4C60 1.79086 58.2091 0 56 0Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9688 39.4922H15.8594C12.959 39.4922 10.5859 41.4697 10.5859 43.8867V44.7656H12.3829C15.2549 44.7656 17.8094 46.012 19.4141 47.9352C21.0189 46.012 23.5734 44.7656 26.4454 44.7656H28.2422V43.8867C28.2422 41.4697 25.8692 39.4922 22.9688 39.4922Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.1407 39.4922H37.0312C34.1309 39.4922 31.7578 41.4697 31.7578 43.8867V44.7656H33.5546C36.4267 44.7656 38.9811 46.012 40.5859 47.9352C42.1907 46.012 44.7451 44.7656 47.6171 44.7656H49.4141V43.8867C49.4141 41.4697 47.0411 39.4922 44.1407 39.4922Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.7266 48.2812H47.6172C44.7168 48.2812 42.3438 50.2588 42.3438 52.6758C42.3438 55.0928 42.3438 60 42.3438 60H60C60 60 60 55.0928 60 52.6758C60 50.2588 57.627 48.2812 54.7266 48.2812Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.3829 48.2812H5.27344C2.37305 48.2812 0 50.2588 0 52.6758C0 55.0928 0 60 0 60H17.6563C17.6563 60 17.6563 55.0928 17.6563 52.6758C17.6563 50.2588 15.2832 48.2812 12.3829 48.2812Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.5547 48.2812H26.4453C23.5449 48.2812 21.1719 50.2588 21.1719 52.6758C21.1719 55.0928 21.1719 60 21.1719 60H38.8282C38.8282 60 38.8282 55.0928 38.8282 52.6758C38.8282 50.2588 36.4551 48.2812 33.5547 48.2812Z",
    fill: "#CCCCCC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_10979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemaSeat);
export default __webpack_public_path__ + "static/media/cinema-seat.5ea59f946743889229697fb9ef3c4250.svg";
export { ForwardRef as ReactComponent };